import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'lineBreak',
  standalone: true,
})
export class LineBreakPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(value: string | null | undefined): SafeHtml {
    if (!value) return '';
    
    // Convert literal \n characters (from server) to <br> tags
    // Also handle actual newline characters if they exist
    const html = String(value)
      .replace(/\\n/g, '<br>')  // Replace literal \n strings
      .replace(/\n/g, '<br>');   // Replace actual newline characters
    
    // Sanitize and return as SafeHtml
    return this.sanitizer.sanitize(1, html) || '';
  }
}